import { ChevronRightIcon } from "@heroicons/react/24/outline"

export const Unauthorized = () => {
    return (
        <div className="flex items-center justify-between  p-10 rounded-lg">
            {/* <div>
                <LockClosedIcon className="h-28 w-28" />
            </div> */}
            <div className="w-fit">
                <h2 className="mb-3 text-3xl tracking-tight text-gray-900 dark:text-white">Oops ! Permission denied.</h2>
                <p className="mb-3 text-gray-500 dark:text-gray-300">
                    You are not allowed to access this content, please contact administrator.
                </p>
                <a href="/" className="inline-flex items-center font-medium text-blue-600 dark:text-blue-400">
                    Contact Administrator
                    <ChevronRightIcon className="h-4 w-4" />
                </a>
            </div>
        </div>
        // <div className="h-[80vh] w-full flex items-center justify-center">
        // </div>
    )
}